module.exports = __webpack_public_path__ + "static/img/y6.c557f180.jpg";